import {Injectable} from '@angular/core';
import {CrudService} from '@ngx-ivengi/crud';
import {Device} from './device.model';

@Injectable()
export class DeviceService extends CrudService<Device> {
  public entityType = Device;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/device/device.service.ts